import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivateChild, CanActivate {

  constructor(private authService: AuthenticationService, private router: Router) { }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.authService.isAuthenticated()) {
      return of(true);
    } else {
      return this.authService.RefreshAccessToken().pipe(
        map((response: any) => {
          console.log(event);
          if (response.succeeded) {
            console.log("token refreshed");
            this.authService.setToken(response.data.token, response.data.refreshToken);
            return true;
          }
          else {
            console.log("refresh token error");
            this.router.navigate(['/login']);
            return false;
          }

        }),
        catchError(() => {
          console.log("refresh token error");
          this.router.navigate(['/login']);
          return of(false);
        })
      );
    }
  }



  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    else {
      return true;
    }
  }

}
